/** Office dates with a public source. A saved calendar date is still the operator's own entry. */

export type PublishedDeadline = {
  id: string;
  consoleKind: string;
  itemId: string;
  title: { en: string; es: string };
  /** The office's filing date. May 15, 2027 is a Saturday, so the Comptroller date moves to Monday. */
  date: string;
  /** Thirty days before the filing date, so the paper is ready. */
  prepareBy: string;
  source: { en: string; es: string };
};

export const PUBLISHED_DEADLINES: PublishedDeadline[] = [
  {
    id: 'tx-pir-2027',
    consoleKind: 'dod-contracts-compliance',
    itemId: 'tx-franchise-account-status',
    title: {
      en: 'Texas Public Information Report',
      es: 'Reporte de Información Pública de Texas',
    },
    date: '2027-05-17',
    prepareBy: '2027-04-17',
    source: {
      en: 'Texas Comptroller: the annual report and Public Information Report are due May 15. In 2027 that date is a Saturday, so the office date is Monday, May 17. This is not a filing receipt.',
      es: 'Contralor de Texas: el reporte anual y el Reporte de Información Pública vencen el 15 de mayo. En 2027 esa fecha es sábado, así que la fecha de la oficina es el lunes 17 de mayo. Esto no es un recibo de presentación.',
    },
  },
  {
    id: 'tx-formation-report-2027',
    consoleKind: 'business-creation-compliance',
    itemId: 'periodic-report',
    title: {
      en: 'Texas franchise report and Public Information Report',
      es: 'Reporte de franquicia de Texas y Reporte de Información Pública',
    },
    date: '2027-05-17',
    prepareBy: '2027-04-17',
    source: {
      en: 'Texas Comptroller: an annual report, when one is required, is due May 15. In 2027 that date is a Saturday, so the office date is Monday, May 17. Skip this if the company is not a Texas entity. This is not a filing receipt.',
      es: 'Contralor de Texas: un reporte anual, cuando se exige, vence el 15 de mayo. En 2027 esa fecha es sábado, así que la fecha de la oficina es el lunes 17 de mayo. Omita esto si la empresa no es de Texas. Esto no es un recibo de presentación.',
    },
  },
];

export const publishedDeadlinesFor = (consoleKind: string): PublishedDeadline[] => (
  PUBLISHED_DEADLINES.filter((row) => row.consoleKind === consoleKind)
);
